import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { getTeamEnumValues } from '@/enum/TeamEnum';
import { getAstroSignEnumValues } from '@/enum/AstroSignEnum';

const DoudouZod = z.object({
  id: z.number(),
  name: z.string(),
  job: z.string().nullish(),
  avatar: MediaZod.nullish(),
  size: z.number().nullish(),
  xp: z.number().nullish(),
  team: z.enum(getTeamEnumValues()).nullish(),
  astro: z.enum(getAstroSignEnumValues()).nullish(),
});

export { DoudouZod };
export type DoudouType = z.infer<typeof DoudouZod>;
